import { useParams, useNavigate } from "react-router-dom";
import EventForm from "../../components/forms/EventForm";
import { api } from "../../utils/apiClient";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import ContentLoader from "../../utils/ContentLoader";


export default function EventFormPage() {
  const { id } = useParams(); // <-- will be undefined for create
  const navigate = useNavigate();

  const [initialData, setInitialData] = useState({});
  const [eventTitleOptions, setEventTitleOptions] = useState([]);
  const [eventDioceseOptions, setEventDioceseOptions] = useState([]);
  const [eventParisOptions, setEventParisOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editData, setEditData] = useState(null);

  //console.log("-------------->", eventDioceseOptions);

  // Fetch event if editing
  useEffect(() => {
    if (id) {
      const fetchInventory = async () => {
        try {
          setLoading(true);
          const res = await api.get(`/events/${id}`);
          setInitialData(res.data.data);
          if (!res.data.status) {
            toast.error(res?.data?.message || "Failed to fetch event");
          }
        } catch (err) {
          toast.error(err?.res?.data?.message || "Something went wrong");
          navigate("/events");
        } finally {
          setLoading(false);
        }
      };
      fetchInventory();
    }
  }, [id]);

  useEffect(() => {
    fetchEventTitles();
    // fetchDioceses();
  }, []);


  const fetchEventTitles = async () => {
    try {
      const res = await api.get("/event-types");

      const options = res.data.data.map(item => ({
        value: item.id,
        label: item.name
          .split("_")
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
      }));

      setEventTitleOptions(options);
    } catch (err) {
      console.error("Failed to fetch event titles", err);
    }
  };

  // const fetchDioceses = async () => {
  //   try {
  //     const res = await api.get("/dioceses");

  //     const options = res.data.map(item => ({
  //       value: item.id,
  //       label: item.name
  //     }));

  //     setEventDioceseOptions(options);

  //   } catch (err) {
  //     console.error("Failed to fetch dioceses", err);
  //   }
  // };


  // const fetchParishes = async (dioceseId) => {
  //   try {
  //     const res = await api.get(`/parishes?diocese_id=${dioceseId}`);

  //     const options = res.data.map(item => ({
  //       value: item.id,
  //       label: item.name,
  //       name: item.name,         // church name
  //       latitude: item.latitude, // parish latitude
  //       longitude: item.longitude // parish longitude
  //     }));

  //     setEventParisOptions(options);

  //   } catch (err) {
  //     console.error("Failed to fetch parishes", err);
  //   }
  // };

  const handleSubmit = async (formData) => {
    try {
      setLoading(true);

      if (id) {
        await api.post(`/events/update/${id}`, formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });

        toast.success("Event updated successfully");

      } else {
        await api.post("/events", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });

        toast.success("Event created successfully");
      }

      navigate("/events");

    } catch (err) {

      const errorMessage =
        Object.values(err?.response?.data?.errors || {})?.[0]?.[0] ||
        err?.response?.data?.message ||
        "Something went wrong";

      toast.error(errorMessage);

    } finally {
      setLoading(false);
    }
  };

  if (loading) return <ContentLoader />;


  return <EventForm
    onSubmit={handleSubmit}
    onCancel={() => navigate("/events")}
    initialData={initialData}
    eventTitleOptions={eventTitleOptions}
    eventDioceseOptions={eventDioceseOptions}   // pass dioceses
  //  eventParisOptions={eventParisOptions}       // pass parishes
  //  fetchParishes={fetchParishes}              // pass callback
  />;
}